import { getSuggestionQuestions } from "@/api/chat";
/**
 * 将各种时间输入格式（秒/毫秒时间戳、ISO 字符串、YYYY-MM-DD）统一格式化为 'YYYY-MM-DD HH:mm:ss'
 * 对于仅为日期的字符串（YYYY-MM-DD）只返回日期，不加时间
 */
const formatTime = (time) => {
  // 兼容时间戳（秒/毫秒）、ISO 字符串或日期字符串（YYYY-MM-DD）
  if (time === null || time === undefined || time === "") return "";
  const raw = String(time);
  let d = null;
  if (/^\d+$/.test(raw)) {
    // 纯数字：按秒或毫秒判断
    if (raw.length === 10) d = new Date(Number(raw) * 1000);
    else d = new Date(Number(raw));
    if (isNaN(d.getTime())) {
      // 兜底再尝试秒->毫秒
      d = new Date(Number(raw) * 1000);
    }
  } else {
    // 非纯数字：优先按字符串解析
    d = new Date(raw);
    if (isNaN(d.getTime())) {
      const asNum = Number(raw);
      if (!isNaN(asNum)) d = new Date(asNum);
    }
  }
  if (!d || isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  const y = d.getFullYear();
  const m = pad(d.getMonth() + 1);
  const day = pad(d.getDate());
  const hh = pad(d.getHours());
  const mm = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  // 如果原始是日期字符串（仅 YYYY-MM-DD），不展示 00:00，直接返回日期
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return `${y}-${m}-${day}`;
  return `${y}-${m}-${day} ${hh}:${mm}:${ss}`;
};
//金额，面积等加入千分符
const dataFormat = (data) => {
  if (data != "" && data != undefined) {
    var num = parseFloat(data).toFixed(2).toString().split("."); // 分隔小数点
    var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
    var res = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      if (i % 3 === 0 && i !== 0) {
        res.push(","); // 添加分隔符
      }
      res.push(arr[i]);
    }
    res.reverse(); // 再次倒序成为正确的顺序
    if (num[1]) {
      // 如果有小数的话添加小数部分
      res = res.join("").concat("." + num[1]);
    } else {
      res = res.join("");
    }
    return res;
  }
};
const stateFormatHj = (row, column, cellValue) => {
  if (row.indexOf("套数") > -1 && column.indexOf("ts") > -1) {
    return cellValue;
  } else if (cellValue && cellValue != "-") {
    return Number(cellValue)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  } else if (cellValue == "-") {
    return "-";
  } else if (cellValue === 0) {
    return "0.00";
  } else {
    return "-";
  }
};

//表单千分符两位
const stateFormat = (row, column, cellValue) => {
  if (cellValue && cellValue != "-") {
    return Number(cellValue)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  } else if (cellValue == "-") {
    return "-";
  } else if (cellValue === 0) {
    return "0.00";
  } else {
    return "-";
  }
};
const formatDate = (value) => {
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
};

const formatDateDay = (value) => {
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d;
};
const isDisplay = (value) => {
  var permissionArr = JSON.parse(window.localStorage.getItem("permission"));
  for (var j = 0, len = permissionArr.length; j < len; j++) {
    if (value == permissionArr[j].permission) {
      return true;
    }
  }
  return false;
};

const typeMap = [
  {
    type: "application/pdf",
    icon: "PDF",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/msword",
    icon: "DOC",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    icon: "DOCX",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/vnd.ms-excel",
    icon: "XLS",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: "XLSX",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/vnd.ms-powerpoint",
    icon: "PPT",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    icon: "PPTX",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "text/plain",
    icon: "TXT",
    isImage: false,
    isDocument: true,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "image/jpeg",
    icon: "JPEG",
    isImage: true,
    isDocument: false,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "image/jpg",
    icon: "JPEG",
    isImage: true,
    isDocument: false,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
  {
    type: "image/png",
    icon: "PNG",
    isImage: true,
    isDocument: false,
    limitSize: 10 * 1024 * 1024, // 10MB
  },
];
// 获取文件类型图标
const getFileIcon = (fileType) => {
  const file = typeMap.find((item) => item.type === fileType);
  return file ? file.icon : "unknown";
};

// 定义图片类型的MIME类型数组
const imageMimeTypes = typeMap
  .filter((item) => item.isImage)
  .map((item) => item.type);

// 定义办公文档类型的MIME类型数组
const documentMimeTypes = typeMap
  .filter((item) => item.isDocument)
  .map((item) => item.type);

const generateSuggestionByFiles = async (fileLists) => {
  // 处理空数组情况
  if (!fileLists || fileLists.length === 0) {
    return "请选择文件";
  }
  // 从文件列表中提取唯一的文件类型
  const uniqueTypes = [...new Set(fileLists.map((file) => file.type))];
  // 只有 xlsx 或 xls 文件
  const isAllExcel = uniqueTypes.every(
    (type) =>
      type === "application/vnd.ms-excel" ||
      type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  );
  if (isAllExcel) {
    return "请判断附件是否符合《总局版土地增值税清算申报表模板》为我匹配最优方案";
  }
  try {
    const res = await getSuggestionQuestions({
      content: "推荐",
      model: "文件指令推荐",
      modelId: 8,
      nameLists: fileLists.map((file) => file.name),
    });

    if (res && res.messages && res.messages.length > 0) {
      return res.messages[0];
    }
  } catch (error) {}

  // 检查是否所有文件都是图片
  const isAllImages = uniqueTypes.every((type) =>
    imageMimeTypes.includes(type)
  );
  // 条件1：只有图片 -> 描述图片内容
  if (isAllImages) {
    return "描述图片内容";
  }

  // 条件2：包含非图片文件 -> 总结文件内容
  return `总结文件内容`;
};
export {
  formatTime,
  dataFormat,
  stateFormatHj,
  stateFormat,
  formatDate,
  formatDateDay,
  isDisplay,
  getFileIcon,
  generateSuggestionByFiles,
  typeMap,
  imageMimeTypes,
  documentMimeTypes,
};
